export default __webpack_public_path__ + "static/media/close.aaac2aaa.svg";